import { Link } from 'react-router-dom';
import { useAgents } from '@/lib/api/agents';
import { Card } from '@/components/ui/Card';
import { buttonClasses } from '@/components/ui/Button';
import { QueryState } from '@/components/QueryState';
import { SkeletonRows } from '@/components/ui/Skeleton';
import { CreateAgentForm } from '@/features/agents/CreateAgentForm';
import { useWorkspacePath } from '@/lib/workspacePath';

export function AgentsListPage() {
  const { data, isLoading, error } = useAgents();
  const ws = useWorkspacePath();

  return (
    <div className="grid gap-6 lg:grid-cols-3">
      <div className="lg:col-span-2">
        <Card title="Agents" description="Configure and chat with your AI agents.">
          <QueryState
            isLoading={isLoading}
            error={error}
            isEmpty={!data || data.length === 0}
            emptyMessage="No agents yet. Create your first agent to get started."
            loadingLabel="Loading agents"
            skeleton={<SkeletonRows rows={4} />}
          >
            <ul className="divide-y divide-gray-100">
              {data?.map((agent) => (
                <li
                  key={agent.id}
                  className="flex items-center justify-between gap-4 py-3"
                  data-testid="agent-list-item"
                >
                  <div className="min-w-0">
                    <p className="truncate font-medium text-gray-900">{agent.name}</p>
                    <p className="truncate text-xs text-gray-500">{agent.model_display_name}</p>
                  </div>
                  <Link
                    to={ws('agents', agent.slug, 'chat')}
                    data-testid="agent-open-chat-link"
                    className={buttonClasses({ size: 'sm' })}
                  >
                    Open agent
                  </Link>
                </li>
              ))}
            </ul>
          </QueryState>
        </Card>
      </div>

      <div>
        <Card title="Create agent">
          <CreateAgentForm />
        </Card>
      </div>
    </div>
  );
}
